import { createAction } from "@reduxjs/toolkit";

export const getNotificationsCount = createAction("getNotificationsCoun");
export const getNotifications = createAction<boolean>("getNotifications");
export const getScreenNotifications = createAction<boolean>("getScreenNotifications");
export const markAsChecked = createAction<number[]>("markAsChecked");
